import cookie from "js-cookie";
import fetch from "isomorphic-fetch";
import { API } from "../config";

export const userSessionExpired = (response, history) => {
  if (response.status == 401) {
    signout(async () => {
      history?.replace({
        pathname: "/signin",
        state: "Your session is expired. please signin.",
      });
    });
  } else {
    return;
  }
};
export const adminForgetPassword = () => {
  return fetch(`${API}/admin-forget-password`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const AdminSignin = (user) => {
  return fetch(`${API}/auth/superadmin-signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const AdminSignup = (user) => {
  return fetch(`${API}/auth/superadmin-signup`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getCookie("token")}`,
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const staffSignin = (user) => {
  return fetch(`${API}/auth/staff-signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
export const staffSigninOrg = (user) => {
  return fetch(`${API}/auth/staff-signin-organization`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const setCookie = (key, value) => {
  if (typeof window !== "undefined") {
    cookie.set(key, value, {
      expires: 1,
    });
  }
};
export const removeCookie = (key) => {
  if (typeof window !== "undefined") {
    cookie.remove(key, {
      expires: 1,
    });
  }
};
export const getCookie = (key) => {
  if (typeof window !== "undefined") {
    return cookie.get(key);
  }
};
export const setLocalstorage = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
    if (value?.staffOrganizations) {
      localStorage.setItem(
        "oranization",
        JSON.stringify(
          value?.staffOrganizations[0]?.organization?.profilePicture
        )
      );
      localStorage.setItem("subscription", JSON.stringify("subscription"));
    }
  }
};
export const removeLocalstorage = (key) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};

export const authentication = (data, next) => {
  setCookie("token", data.token);
  setLocalstorage("user", data.user);
  next();
};

export const signout = (next) => {
  removeCookie("token");
  removeLocalstorage("user");
  removeLocalstorage("oranization");
  next();
  return fetch(`${API}/signout`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      return err;
    });
};
export const profilePicture = () => {
  if (typeof window !== "undefined") {
    // Check if window is defined
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      const oranization = localStorage.getItem("oranization");
      if (oranization) {
        return JSON.parse(oranization);
      } else {
        return false;
      }
    }
  }
  return false; // Return false if window is undefined (server-side)
};
export const showSubscription = () => {
  if (typeof window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      const oranization = localStorage.getItem("subscription");
      if (oranization) {
        return JSON.parse(oranization);
      } else {
        return false;
      }
    }
  }
  return false;
};
export const isAuth = () => {
  if (typeof window !== "undefined") {
    // Check if window is defined
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      const user = localStorage.getItem("user");
      if (user) {
        return JSON.parse(user);
      } else {
        return false;
      }
    }
  }
  return false; // Return false if window is undefined (server-side)
};
export const forgotPassword = (email) => {
  return fetch(`${API}/forgot-password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};

export const resetPassword = (resetInfo) => {
  return fetch(`${API}/reset-password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(resetInfo),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => err);
};
